import type { DemoRoute, DemoState } from "./types.js";

const ROUTES: readonly DemoRoute[] = [
  "inicio",
  "marca",
  "painel",
  "convite",
  "camera",
  "galeria",
  "album",
  "telao",
  "moderacao",
  "fim",
];

export function parseRoute(hash: string): DemoRoute {
  const name = hash.replace(/^#\/?/, "");
  return ROUTES.find((route) => route === name) ?? "painel";
}

export function guardRoute(route: DemoRoute, state: DemoState): DemoRoute {
  if (!state.brand) {
    return route === "marca" ? "marca" : "inicio";
  }
  if (
    state.audience === "client" &&
    (route === "marca" || route === "painel" || route === "moderacao")
  ) {
    return "convite";
  }
  if (!state.guest && (route === "camera" || route === "galeria")) {
    return "convite";
  }
  return route;
}

export function routeHref(route: DemoRoute): string {
  return `#/${route}`;
}
